import type Client from '../client'
import ProductVariation from './product-variation'

export default class Product {
  constructor(private client: Client) {}

  get variations(): ProductVariation {
    return new ProductVariation(this.client)
  }
}
